import React from 'react';
import Header from '../components/Header';
import MotDuDirecteur from './MotDuDirecteur';
import Historique from './Historique';
import Footer from '../components/Footer';
import useSEO from '../components/SEO';

const AboutPage: React.FC = () => {
    useSEO({
        title: "À Propos - ISTMECH",
        description: "Histoire, mission et parcours de l'Institut Supérieur de Technologie Médicale du Cap-Haïtien (ISTMECH).",
        keywords: "ISTMECH, histoire, à propos, institut supérieur, technologie médicale",
        url: "https://www.istmech.edu.ht/a-propos",
        image: "https://www.istmech.edu.ht/og-image.png"
    });

    return (
        <div className="App">
            <Header />
            <main className="pt-20">
                <MotDuDirecteur />
                <Historique />
            </main>
            <Footer />
        </div>
    );
};

export default AboutPage;
